'use strict'

function cosine (i,N) {
  return Math.sin(3.141592653589793*i/(N-1))
}

module.exports = cosine
